import {
  FETCH_USER_ORGANIZATIONS_STATS,
  GET_USER_ORGANIZATIONS,
  GET_USER_ORGANIZATIONS_FAIL,
  GET_USER_ORGANIZATIONS_STATS,
  SET_LOADING,
  UPDATE_USER_ORGANIZATIONS,
} from './actions/userOrganizations'
import { RepositoryFactory } from '@/api/RepositoryFactory'

const approvementsApi = RepositoryFactory.get('approvements')
const UserOrganizations = RepositoryFactory.get('userOrganizations')

export default {
  namespaced: true,
  state: {
    userOrganizations: [],
    pagination: {},
    loading: false,
    approvStatistics: {},
  },
  getters: {
    getUserOrganizations: state => state.userOrganizations,
    getPagination: state => state.pagination,
    getLoading: state => state.loading,
    getUserOrganizationById(state) {
      return id =>
        state.userOrganizations.find(item => Number(item.id) === Number(id))
    },
  },
  actions: {
    [GET_USER_ORGANIZATIONS]: ({ commit }, settings) => {
      commit(SET_LOADING, true)
      UserOrganizations.getList(settings)
        .then(res => {
          const userOrganizations = res.data.items
          const pagination = res.data._meta

          commit(UPDATE_USER_ORGANIZATIONS, { userOrganizations, pagination })
        })
        .catch(() => commit(GET_USER_ORGANIZATIONS_FAIL))
        .finally(() => commit(SET_LOADING, false))
    },
    async [GET_USER_ORGANIZATIONS_STATS]({ commit }) {
      commit(SET_LOADING, true)
      try {
        const { data } = await approvementsApi.fetchApprovements(
          'usersOrganizations',
        )

        commit(FETCH_USER_ORGANIZATIONS_STATS, data.by_meaning)
      } catch (error) {
        console.log(`error `, error)
      } finally {
        commit(SET_LOADING, false)
      }
    },
  },
  mutations: {
    [FETCH_USER_ORGANIZATIONS_STATS](state, payload) {
      state.approvStatistics = payload
    },
    [UPDATE_USER_ORGANIZATIONS]: (state, { userOrganizations, pagination }) => {
      state.userOrganizations = userOrganizations
      state.pagination = pagination
      state.loading = false
    },
    [SET_LOADING]: (state, flag) => {
      state.loading = Boolean(flag)
    },
    [GET_USER_ORGANIZATIONS_FAIL]: state => {
      state.loading = false
    },
  },
}
